import { useQueryClient } from "react-query";
import { useMutation } from "react-query";
import { notification } from "antd";
import { isError } from "utils/api/models/api-response";
import { EditClassification } from "services/classifications";
import i18next from "i18next";

export default function UpdateClassification() {
  const queryClient = useQueryClient();
  return {
    ...useMutation(EditClassification, {
      onSuccess: async (res) => {
        if (!isError(res)) {
          notification.open({
            message:
              i18next.language === "ar"
                ? "تم التعديل بنجاح"
                : "Updated successfully",
          });
          queryClient.invalidateQueries("classifications");
        }
      },
    }),
  };
}
